import { useQuery } from '@tanstack/react-query';
import { fetchOutgoingTransactionTracing } from '@/api/transactions';

export const tracingKeys = {
  detail: (txId: string) => ['fiber-tracing', txId] as const,
};

export function useOutgoingTransactionTracing(txId: string) {
  return useQuery({
    queryKey: tracingKeys.detail(txId),
    queryFn: () => fetchOutgoingTransactionTracing(txId),
    staleTime: 60_000,
  });
}
